import React from 'react';
import { InputErrorMessage } from 'components/InputErrorMessage/InputErrorMessage';
import * as S from './Card.styles';
export const Card = /*#__PURE__*/React.forwardRef(({
  children,
  width,
  height,
  variant = 'regular',
  hasError = false,
  errorMessage,
  testId
}, ref) => {
  const renderChildrenWithVariant = () => {
    return React.Children.map(children, child => {
      if (! /*#__PURE__*/React.isValidElement(child)) {
        return child;
      }
      const props = {
        $variant: variant,
        $hasError: hasError
      };
      return /*#__PURE__*/React.cloneElement(child, props);
    });
  };
  return /*#__PURE__*/React.createElement(S.CardWrapper, {
    "data-testid": testId
  }, /*#__PURE__*/React.createElement(S.CardContainer, {
    ref: ref,
    $width: width,
    $height: height,
    $variant: variant,
    $hasError: hasError
  }, renderChildrenWithVariant()), hasError && errorMessage ? /*#__PURE__*/React.createElement(InputErrorMessage, null, errorMessage) : null);
});
export const CardHeader = S.CardHeader;
export const CardHeaderWithIcon = S.CardHeaderWithIcon;
export const CardBody = S.CardBody;